/**
 * Patronage block — the seal at the bottom of the marketing site declaring:
 *  - Vigilant Entities is part of M3 Holdings (m3holdingsgroup.com)
 *  - Operated under the patronage of H.E. Sheikh Mansoor Bin Khalifa Al Thani
 *    (mansoorbinkhalifa.com)
 */
import React from 'react';
import { ExternalLink, Crown, ShieldCheck } from 'lucide-react';

export default function PatronageBlock({ variant = 'dark' }) {
  const dark = variant === 'dark';
  return (
    <div
      data-testid="patronage-block"
      className={`mt-12 rounded-lg border ${dark ? 'border-white/15 bg-white/[0.03]' : 'border-slate-200 bg-white'} p-6 md:p-8`}
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
        <div className="md:col-span-6">
          <div className={`inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] font-bold ${dark ? 'text-[#8B3FC5]' : 'text-[#5E1F8B]'}`}>
            <Crown size={12}/> Under the Patronage of
          </div>
          <h3 className={`display text-xl md:text-2xl mt-3 leading-snug ${dark ? 'text-white' : 'text-slate-900'}`}>
            H.E. Sheikh Mansoor Bin Khalifa Al Thani
          </h3>
          <p className={`text-sm mt-2 italic ${dark ? 'text-white/70' : 'text-slate-600'}`}>
            Visionary Leader. Innovator. Catalyst for Qatar&apos;s Digital Future.
          </p>
          <a
            href="https://www.mansoorbinkhalifa.com"
            target="_blank" rel="noreferrer"
            data-testid="patronage-mansoor-link"
            className={`mt-4 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] font-bold transition-colors
                        ${dark ? 'text-[#8B3FC5] hover:text-white' : 'text-[#5E1F8B] hover:text-[#0A0A0A]'}`}
          >
            mansoorbinkhalifa.com <ExternalLink size={11}/>
          </a>
        </div>

        <div className={`md:col-span-1 ${dark ? 'border-white/10' : 'border-slate-200'} hidden md:block border-l h-full`}/>

        <div className="md:col-span-5">
          <div className={`inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] font-bold ${dark ? 'text-[#8B3FC5]' : 'text-[#5E1F8B]'}`}>
            <ShieldCheck size={12}/> Part of
          </div>
          <h3 className={`display text-xl md:text-2xl mt-3 leading-snug ${dark ? 'text-white' : 'text-slate-900'}`}>
            M3 Holdings Group
          </h3>
          <p className={`text-sm mt-2 ${dark ? 'text-white/70' : 'text-slate-600'}`}>
            A diversified Qatari holding company invested across technology, real estate, capital and venture.
          </p>
          <a
            href="https://m3holdingsgroup.com"
            target="_blank" rel="noreferrer"
            data-testid="patronage-m3-link"
            className={`mt-4 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] font-bold transition-colors
                        ${dark ? 'text-[#8B3FC5] hover:text-white' : 'text-[#5E1F8B] hover:text-[#0A0A0A]'}`}
          >
            m3holdingsgroup.com <ExternalLink size={11}/>
          </a>
        </div>
      </div>
    </div>
  );
}
